import React from 'react'
import styled from '@emotion/styled'
import { StepIconProps } from '@mui/material'

const StepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
  ({ ownerState }) => ({
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    border: '2px solid #E8E9FD',
    ...(ownerState.active && {
      width: '32px',
      height: '32px',
      backgroundColor: '#3846FF',
      border: 0
    })
  })
)
export function CustomStepIcon(props: StepIconProps) {
  const { active } = props

  return <StepIconRoot ownerState={{ active }}></StepIconRoot>
}
